/** True for images we can pass to an img src; the browser may still fail to decode (e.g. HEIC). */
export function isDisplayableImageFile(mime: string): boolean {
  return typeof mime === "string" && mime.toLowerCase().startsWith("image/");
}
